import { render, staticRenderFns } from "./InstructorResultDetail.vue?vue&type=template&id=7d809386&"
import script from "./InstructorResultDetail.vue?vue&type=script&lang=js&"
export * from "./InstructorResultDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports